import { DialogActions } from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import React from 'react';

interface DialogActionsProps {
  readOnly: boolean;
  nomineeId?: string;
  resells: any[];
  bankAccountId: string;
  selectedCertificate: any;
  hasCessionIntegration: boolean;
  onEdit: () => void;
  onClose: () => void;
  onSave: () => Promise<void>;
  onConfirm: () => Promise<void>;
  onConfirmAndCede: () => void;
}

const ResellDialogActions: React.FC<DialogActionsProps> = ({
  readOnly,
  nomineeId,
  resells,
  bankAccountId,
  selectedCertificate,
  hasCessionIntegration,
  onEdit,
  onClose,
  onSave,
  onConfirm,
  onConfirmAndCede,
}) => {
  return (
    <DialogActions>
      {readOnly && (
        <CustomButton onClick={onEdit} color="primary">
          Editar
        </CustomButton>
      )}

      <CustomButton onClick={onClose} color="secondary">
        {readOnly ? 'Cerrar' : 'Salir'}
      </CustomButton>

      {!readOnly && (
        <>
          {nomineeId ? (
            <CustomButton
              onClick={onSave}
              color="primary"
              disabled={resells.length === 0}
            >
              Guardar
            </CustomButton>
          ) : (
            <>
              <CustomButton
                onClick={onConfirm}
                color="primary"
                disabled={resells.length === 0 || !bankAccountId}
              >
                Confirmar
              </CustomButton>

              <CustomButton
                onClick={onConfirmAndCede}
                color="primary"
                disabled={
                  resells.length === 0 ||
                  !bankAccountId ||
                  !selectedCertificate ||
                  !hasCessionIntegration
                }
              >
                Confirmar y ceder
              </CustomButton>
            </>
          )}
        </>
      )}
    </DialogActions>
  );
};

export default ResellDialogActions;
